import { withErrorBoundary } from 'shared'
import ImageGallery from 'react-image-gallery'

// https://github.com/xiaolin/react-image-gallery
// https://github.com/leandrowd/react-responsive-carousel
// https://github.com/akiran/react-slick
// https://github.com/FormidableLabs/nuka-carousel
const ImageGalleryModal = ({ gallery }) => {
  const renderItem = (item) => {
    return (
      <div className='image-gallery-image'>
        <div className="image-gallery-image-div" style={{ backgroundImage: `url(${item.original})` }} />
      </div>
    )
  }

  const images = gallery.images.map((item) => {
    return { original: item.image_url, thumbnail: item.thumbnail_url };
  });

  return (
    <div className="GalleryModal custom-modal">
      <div className="modal-body">
        <div style={{width: '100%'}}>
          <h1 className="GalleryModal-title custom-heading-community">{gallery.title}</h1>
          <ImageGallery items={images}
            infinite={true} lazyLoad={true}
            showFullscreenButton={false} showPlayButton={false}
            renderItem={renderItem}
          />
        </div>
      </div>
    </div>
  )
}

export default withErrorBoundary(ImageGalleryModal)
